/* eslint-disable max-len */
import React from 'react';

const LogInAs: React.FC<object> = () => {

    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_6575_138730)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM4.85742 7C3.74246 7 2.77847 7.63977 2.30762 8.57129C3.12083 9.73688 4.47098 10.5 6 10.5C7.52882 10.5 8.87816 9.73662 9.69141 8.57129C9.22048 7.63998 8.25738 7 7.14258 7H4.85742ZM6 2C4.89543 2 4 2.89543 4 4C4 5.10457 4.89543 6 6 6C7.10457 6 8 5.10457 8 4C8 2.89543 7.10457 2 6 2Z"
                    fill="#616E6E"
                />
            </g>
            <defs>
                <clipPath id="clip0_6575_138730">
                    <rect
                        width="12"
                        height="12"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default LogInAs;